import { PocSwitch } from 'commons/components/components-wrapper/poc-switch.component';
import { PocIconButton } from 'commons/components/components-wrapper/poc-icon-button.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import React from 'react';
import { AutomationRulesCardLayout, FlexDiv } from '../styled/automation-rules.style';

interface EntityToggleListItemProps {
    id: string;
    name: string;
    enabled: boolean;
    onEdit: (id: string) => void;
    onEnabledChange: (id: string) => void;
}

export const EntityToggleListItem: React.FC<EntityToggleListItemProps> = ({
    id,
    name,
    enabled,
    onEdit,
    onEnabledChange,
}) => (
    <AutomationRulesCardLayout className="spc-btw alg-itm-ctr" padding="8px 0">
        <PocTypography variant="subtitle1" element="h6">
            {name}
        </PocTypography>
        <FlexDiv>
            <PocSwitch
                data-testid="automation-rule-switch"
                checked={enabled}
                controlled
                onClick={() => onEnabledChange(id)}
            />
            <PocIconButton
                data-testid="automation-rule-edit-btn"
                icon="write"
                family="outlined"
                onClick={() => onEdit(id)}
            />
        </FlexDiv>
    </AutomationRulesCardLayout>
);
